// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Glyphicon } from 'react-bootstrap';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ up }) =>
  up ? (
    <Glyphicon glyph='chevron-up' style={{ paddingLeft: '8px' }} />
  ) : (
    <Glyphicon glyph='chevron-down' style={{ paddingLeft: '8px' }} />
  );
